module.exports = __webpack_public_path__ + "img/img(42).04f7f414.jpg";